<template>
    <div>
        <Headers :title="title" />
        <van-tabs v-model="toggleActive" animated>
            <van-tab :title="isHolding">
                <van-list
                style="background: #f8f8f8;"
                v-model="loading"
                :finished="finished"
                @load="onLoad"

                >
                    <van-cell v-for="(item, index) in optionsExhibition" :key="index" @click="goExhibitors(item.id)">
                        <template >
                            <div class="pavilion-img">
                                <img :src="item.main_img && item.main_img.url || logo" alt="">
                            </div>
                            <div class="pavilion-content">
                                <div class="pavilion-content-left">
                                    <div class="cn-name">{{language == 'zh' ? item.base_info.data.cn.name :item.base_info.data.en.name }}</div>
                                </div>
                                <div  class="pavilion-content-right">
                                    <div class="pavilion-content-wrap">
                                        <img class="icon" src="~statics/mobileShouye/time-icon.png" alt="">
                                        <div class="time">{{item.base_info.open_date.substring(0,11)}}~{{item.base_info.close_date.substring(0,11)}}</div>
                                    </div>
                                    <div class="pavilion-content-wrap">
                                        <img class="icon" src="~statics/mobileShouye/location.png" alt="">
                                        <div class="time">{{item.base_info.exh_address || '/'}}</div>
                                    </div>
                                </div>
                            </div>
                        </template>
                    </van-cell>
                </van-list>
            </van-tab>
            <van-tab :title="soonHold">
                <van-empty
                class="custom-image"
                image="../../../../static/mobileShouye/empty-search.png"
                :description="this.$t('header').template_tip"
                />
            </van-tab>
            <van-tab :title="history">
                <van-list
                style="background: #f8f8f8;"
                v-model="loading"
                :finished="finished"
                @load="onLoad"
               
                >
                    <van-cell  v-for="(item, index) in optionsOldExhibition" :key="index" @click="goExhibitors(item.id)">
                        <template >
                            <div class="pavilion-img">
                                <img :src="item.main_img && item.main_img.url" alt="">
                            </div>
                            <div class="pavilion-content">
                                <div class="pavilion-content-left">
                                    <div class="cn-name">{{language == 'zh' ? item.base_info.data.cn.name :item.base_info.data.en.name}}</div>
                                </div>
                                <div  class="pavilion-content-right">
                                    <div class="pavilion-content-wrap">
                                        <img class="icon" src="~statics/mobileShouye/time-icon.png" alt="">
                                        <div class="time">{{item.base_info.open_date.substring(0,11)}}~{{item.base_info.close_date.substring(0,11)}}</div>
                                    </div>
                                    <div class="pavilion-content-wrap">
                                        <img class="icon" src="~statics/mobileShouye/location.png" alt="">
                                        <div class="time">{{item.base_info.exh_address || '/'}}</div>
                                    </div>
                                </div>
                            </div>
                        </template>
                    </van-cell>
                </van-list>
            </van-tab>
        </van-tabs>
        <Footers />
    </div>
</template>

<script>
import Headers from "../mobileExhibition/components/Headers";
import Footers from "../mobileExhibition/components/Footers";
import { mapState } from "vuex";
import api from "@/api";

export default {
    data(){
        return{
            logo: require("../../../../static/no-logo-new.png"),
            optionsExhibition: [
            ],
            optionsOldExhibition:[],
            list: [],
            newoption: [],
            oldoption: [],
            loading: false,
            finished: false,
            toggleActive: 0,
            newoptionEnd: [],
            // title: '展会',
        }
    },
    computed: {
        title(){
            return this.language == 'zh' ? '全球数字贸易云展会平台' : 'Global digital trade cloud exhibition platform'
        },
        language(){
            return localStorage.getItem('language') || 'zh'
        },
        isHolding(){
            return this.language == 'zh' ? '正在办展' : 'Being held'
        },
        soonHold(){
            return this.language == 'zh' ? '即将举办' : 'Coming soon'
        },
        history(){
            return this.language == 'zh' ? '历史展会' : 'History shows'
        },
        ...mapState(["userInfo","language"]),
    },
    created() {
        this.getOptionsExhibition()
        this.getOptionsExhibitionEnd()
    },
    mounted(){
    },
    methods: {
        goExhibitors(_id){
            if(_id == '34' || _id == '41' || _id == '49' || _id == '51' || _id == '55' || _id == '59'){
                this.$router.push({
                    path: '/mobilecomponent',
                    query: {
                        exhibition_id: _id
                    }
                })
            }else{
                this.$router.push({
                    path: '/mobileConsult',
                    query: {
                        exhibition_id: _id
                    }
                })
            }
        },
        onLoad() {
            // 异步更新数据
            // setTimeout 仅做示例，真实场景中一般为 ajax 请求
            setTimeout(() => {
                for (let i = 0; i < 10; i++) {
                this.list.push(this.list.length + 1);
                }

                // 加载状态结束
                this.loading = false;

                // 数据全部加载完成
                if (this.list.length >= 40) {
                this.finished = true;
                }
            }, 1000);
        },
        getOptionsExhibitionEnd(){
            api.getExhibition({
                lasting: '0',
                status: '3',
                company_id: '582'
            }).then((res)=>{
                if(res.res == 1){
                    res.list.forEach((item,index) => {
                        // this.optionsExhibitionEnd = res.list
                        if(   item.id != 15 && item.id != 14){
                            this.newoptionEnd.push(item)
                            this.optionsOldExhibition = this.newoptionEnd
                        }
                    });
                }
            })
        },
        getOptionsExhibition(){
            // api.getExhibition({
            //     lasting: '0'
            // }).then((res)=>{
            //     if(res.res == 1){
            //         res.list.forEach((item,index) => {
            //             if(item.id == 21 || item.id == 34){
            //                 this.newoption.push(item)
            //                 this.optionsExhibition = this.newoption
            //             }
            //             if(item.id == 25 || item.id == 31){
            //                 this.oldoption.push(item)
            //                 this.optionsOldExhibition = this.oldoption
            //             }
            //         });
            //     }
            // })
            api.getExhibition({
                lasting: '0',
                status: '2',
                company_id: '582'
            }).then((res)=>{
                if(res.res == 1){
                    // res.list.forEach((item,index) => {
                    //     if(item.id == 21 || item.id == 31){
                    //         this.newoption.push(item)
                    //         this.optionsExhibition = this.newoption
                    //     }
                    // });
                    console.log(res)
                    this.optionsExhibition = res.list
                }
            })
        },
    },
    components: {
        Headers,
        Footers
    },
}
</script>

<style lang="scss" scoped>
/deep/ .van-notice-bar__content{
    line-height: .32rem;
    color: #ffffff;
    opacity: 1;
    font-size: 12px
}
/deep/ .van-notice-bar__left-icon{
    color: #fff;
}
/deep/ .van-notice-bar__right-icon{
    color: #fff;
}
/deep/ .van-nav-bar__title{
    color: #fff;
}
/deep/ .van-hairline--bottom{
    background: #194b96;
}
/deep/ .van-icon-search{
    color: #fff;
}
/deep/ .van-tabs__content--animated{
    overflow: scroll;
    height: calc(100vh - 1.1rem - 80px);
    max-height: calc(100vh - 1.1rem - 80px);
    /*定义滚动条高宽及背景*/
    &::-webkit-scrollbar {
        width: 1px;
    }
    /*定义滚动条*/
    &::-webkit-scrollbar-thumb {
        border-radius: 10px;
        -webkit-box-shadow: inset 0 0 5px #fff;
        background: #fff;
    }
    /*定义滚动条轨道*/
    &::-webkit-scrollbar-track {
        -webkit-box-shadow: inset 0 0 5px #fff;
        border-radius: 0;
        background: rgba(0, 0, 0, 0.1);
    }
}
/deep/ .van-cell{
    width: 92%;
    margin: .24rem auto;
    padding: unset;
    // &:nth-last-of-type(){
        
    // }
}
/deep/ .van-list{
    .van-cell:last-of-type {
        margin-bottom: 1.1rem !important; 
    }
} 
/deep/ .van-tab--active{
   color: #377cfe;
}
/deep/ .van-tabs__line{
    background: #377cfe;
    width: 1.12rem;
    height: .04rem;
}
.custom-image{
    padding: unset;
    margin: 5rem auto;
}
.pavilion-img{
    width: 6.9rem;
    height: 4.3rem; 
    // background: #d5e8ff;
    display: flex;
    justify-content: center;
    align-items: center;
    img{
        width: 100%;
        max-height: 4.3rem;
        object-fit: contain;
        
        // width: 100%;
        // height: 100%;
        // object-fit: fill;
    }
}
.pavilion-content{
    display: flex;
    flex-direction: column;
    height: 1.04rem;
    background: #fff;
    margin: .24rem .2rem;
    .pavilion-content-left{
        .cn-name{
            color: #333;
            font-size: 14px;
            line-height: .4rem;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
        }
    }
    .pavilion-content-right{
        display: flex;
        justify-content: space-between;
        margin-top: .12rem;
        .pavilion-content-wrap{
            display: flex;
            justify-content: center;
            align-items: center;
            .icon{
                width: .28rem;
                height: .28rem;
                margin-right: .1rem;
            }
            .time{
                color: #999999;
                font-size: 12px;
                line-height: .34rem;
            }
        }
    }
    // .pavilion-content-right{
    //     display: flex;
    //     justify-content: space-between;
    //     width: 1.48rem;
    //     background: #194b96;
    //     border-radius: 12px;
    //     display: flex;
    //     justify-content: center;
    //     align-items: center;
    //     color: #fff;
    //     font-size: 12px;
    // }
}
</style>


// WEBPACK FOOTER //
// src/views/mobile/mobileExhibitors/index.vue